<template>
  <article>
    <h2>Composite 26</h2>
    <br />
    <p>
      Bienvenue chez Composite, rendez-vous bimestriel dédié à la créativité
      numérique et au réseautage pour stimuler les échanges et la pollinisation
      entre les créateurs, les entreprises et les professionnels œuvrant dans le
      domaine du numérique.
    </p>
    <p>Notre but : inspirer !</p>

    <p>Indications pour vous brancher :</p>
    <ul class="icon-list">
      <li>
        <i class="fas fa-desktop"></i> Il est essentiel que tu utilises un
        ordinateur pour te brancher à ta session car les iPhones et les
        <strong>iPads ne sont pas compatibles</strong> avec la plateforme. Si ce
        n’est pas possible pour toi, tu peux utiliser une tablette Android.
      </li>
      <li>
        <i class="fa fa-chrome"></i> L’utilisation des navigateurs Google Chrome
        ou Firefox est requise. Tu peux cliquer
        <a
          href="https://support.google.com/chrome/answer/95346?co=GENIE.Platform%3DDesktop&hl=fr"
          target="_blank"
          rel="noopener noreferrer"
        >
          ici
        </a>
        pour l’installer, si tu ne l’as pas.
      </li>
      <li>
        <i class="fas fa-video" aria-hidden="true"></i>Il faut absolument que tu
        autorises la connexion vidéo et audio, à chaque fois que demandé.
      </li>
      <li>
        <i class="fas fa-headphones" aria-hidden="true"></i>Il est possible que
        l’audio devienne muet lorsque tu changes de salles ou de tables, il
        suffit simplement de le réactiver.
      </li>
      <li>
        <i class="fas fa-phone-slash"></i>Nous t’invitons à éteindre ton
        téléphone pour profiter pleinement du moment que tu passeras avec nous.
      </li>
    </ul>
    <br />
    <p>Bon événement !</p>
    <br />
    <br />
  </article>
</template>

<script>
export default {
  props: {},
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  padding: 0;
  margin-top: 16px;

  li {
    padding: 8px 0;
    vertical-align: center;
  }
  i {
    padding-right: 8px;
  }
}

.footer {
  height: 36px;
  object-fit: cover;
}
</style>
